export enum AlertType {
  missingClockIn = 'missing_clock_in',
  missingClockOut = 'missing_clock_out',
  missingBreakTime = 'missing_break_time',
  insufficientBreakDuration = 'insufficient_break_duration',
}

export enum PopoverTypeToShow {
  Info = 'info',
  Count = 'count',
}

export const PeriodState = {
  pending: 'pending',
  approved: 'approved',
  in_progress: 'in_progress',
}

export interface NavigationParams {
  year: string
  month: string
  day: string
  periodType: string
  employeeId?: string
}
